import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbField } from "abreact/form/AbField";
import * as AbFormHooks from "abreact/form/AbFormHooks";
import { AbDateDataValueInput } from "abreact/input/AbDateDataValueInput";
import * as React from "react";
export function AbDateField(props) {
  const viewModel = AbFormHooks.useDataValueFieldViewModel("ab-date-field", props);
  if (!viewModel) {
    return null;
  }
  return /*#__PURE__*/React.createElement(AbField, _extends({}, viewModel.fieldProps, {
    singleLine: true
  }), /*#__PURE__*/React.createElement(AbDateDataValueInput, _extends({}, viewModel.inputProps, {
    valueRenderer: props.valueRenderer,
    earliestDate: props.earliestDate,
    latestDate: props.latestDate
  })));
}
//# sourceMappingURL=AbDateField.js.map
